export function getTenantFromHostname(hostname: string | null): string | null {
  if (!hostname) return null

  // For localhost development - check for port-based or query param tenant
  if (hostname.includes('localhost') || hostname.includes('-local')) {
    // Option 1: Use URL query parameter for development
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search)
      const tenant = urlParams.get('tenant')
      if (tenant) return tenant
    }

    // Option 2: Use default tenant from env
    return process.env.defaultTenant || 'dev'
  }

  // Extract subdomain (tenant.mydashbi.com -> tenant)
  const parts = hostname.split('.')
  if (parts.length >= 3) {
    const subdomain = parts[0]

    return subdomain !== 'www' ? subdomain : null
  }

  return null
}
